import { ReactNode } from 'react';

interface StatCardProps {
  label: string;
  value: string;
  tone?: 'neutral' | 'success' | 'warning' | 'danger' | 'info';
  icon?: ReactNode;
}

const toneClasses: Record<NonNullable<StatCardProps['tone']>, string> = {
  neutral: 'border-zt-border text-slate-200',
  success: 'border-zt-primary/30 text-zt-primary',
  warning: 'border-zt-warning/30 text-zt-warning',
  danger: 'border-zt-danger/30 text-zt-danger',
  info: 'border-zt-info/30 text-zt-info',
};

function StatCard({ label, value, tone = 'neutral', icon }: StatCardProps) {
  return (
    <div className={`min-w-0 rounded-xl border bg-zt-surface p-4 ${toneClasses[tone]}`}>
      <div className="flex min-w-0 items-center justify-between gap-2">
        <div className="min-w-0 truncate text-2xl font-bold">{value}</div>
        {icon && <div className="shrink-0 text-zt-muted">{icon}</div>}
      </div>
      <div className="mt-1 truncate text-sm text-zt-muted">{label}</div>
    </div>
  );
}

export default StatCard;
